import React, { useContext, useState } from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import toast from "react-hot-toast";
import { Auth } from "aws-amplify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ClipLoading } from "../../../components/Loadings";
import { changePasswordValidationSchema } from "../../../Utility/Validations";
import { changePasswordLogoutProcess } from "../../../Utility/ApiService";
import { Context } from "../../../Utility/ContextManager";

export default function ChangePasswordModal({ showPassword, setShowPassword, showSuccessMessage }) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors: passwordErrors },
  } = useForm({
    resolver: yupResolver(changePasswordValidationSchema),
  });
  const [loading, setLoading] = useState(false);
  const { user } = useContext(Context);

  const handleClose = () => {
    setLoading(false);
    setShowPassword(false);
    reset();
  };

  const handleSave = async (data) => {
    try {
      setLoading(true);
      const currentUser = await Auth.currentAuthenticatedUser();
      await Auth.changePassword(currentUser, data.oldPassword, data.newPassword);
      showSuccessMessage("Your password has been updated");
      changePasswordLogoutProcess(user.id);
      handleClose();
    } catch (error) {
      setLoading(false);
      console.log("Change Password error ", error);
      toast.error(error.message || error);
    }
  };

  return (
    <Modal className="modal-style-1 w-100" centered show={showPassword} onHide={handleClose}>
      <Modal.Body>
        <form onSubmit={handleSubmit(handleSave)}>
          <h4 className="mb-0 modal-header">Change Password</h4>
          <div>
            <div className={"mb-3 " + (passwordErrors?.oldPassword && "error")}>
              <label className="form-label">Old Password</label>
              <input
                disabled={loading}
                type="password"
                className="form-control"
                placeholder="Enter Old Password"
                {...register("oldPassword")}
              />
              {passwordErrors?.oldPassword && <p className="passwordError">{passwordErrors?.oldPassword?.message}</p>}
            </div>

            <div className={"mb-3 " + (passwordErrors?.newPassword && "error")}>
              <label className="form-label">New Password</label>
              <input
                disabled={loading}
                type="password"
                className="form-control"
                placeholder="Enter New Password"
                {...register("newPassword")}
              />
              {passwordErrors?.newPassword && <p className="passwordError">{passwordErrors?.newPassword?.message}</p>}
            </div>

            <div className={"mb-3 " + (passwordErrors?.confirmNewPassword && "error")}>
              <label className="form-label">Confirm New Password</label>
              <input
                disabled={loading}
                type="password"
                className="form-control"
                placeholder="Re-Enter New Password"
                {...register("confirmNewPassword")}
              />
              {passwordErrors?.confirmNewPassword && (
                <p className="passwordError">{passwordErrors?.confirmNewPassword?.message}</p>
              )}
            </div>
          </div>

          <Row>
            <Col xs={6}>
              <Button variant="warning" className="w-100" onClick={handleClose}>
                Close
              </Button>
            </Col>
            <Col xs={6}>
              {!loading ? (
                <Button variant="primary" type="submit" className="w-100">
                  Save
                </Button>
              ) : (
                <ClipLoading loading={loading} />
              )}
            </Col>
          </Row>
        </form>
      </Modal.Body>
    </Modal>
  );
}
